import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import React, {useEffect, useRef, useState} from 'react';
import ItemEdit from "./ItemEdit";
import MoreInfoModal from "../../../components/MoreInfoModal";
import {errorHandle} from "../../../global/errorHandle";
import {setLoader} from "../../../store/slice/dashboard";
import {useDeleteFinancingPlanMutation, useLazyGetFinancingPlanQuery} from "../../../store/service/quartelyApi";
import MoreInfoButton from "../../../UI/MoreInfoButton";
import AddRowButton from "../../../UI/AddRowButton";

const FinancingPlan = ({translations, data, reportId, hiddenSectionHandler, isReportSubmitted}) => {
    const dispatch = useDispatch();
    const headerRef = useRef();
    const thead = useRef();
    const [isOpenMoreInfo, setOpenMoreInfo] = useState(false)
    const [isOpenEdit, setIsOpenEdit ]= useState({show: true, id: null});
    const [isOpenToAdd, setIsOpenToAdd ]= useState(false);
    const [cellWidths, setCellWidths] = useState([]);

    const [financingPlanData, setFinancingPlanData ]= useState(data)

    const [deleteFinancingPlan, {
        data: deleteFinancingPlanData,
        isLoading: deleteFinancingPlanIsLoading,
        error: deleteFinancingPlanError,
        isError: deleteFinancingPlanIsError,
        isSuccess: deleteFinancingPlanIsSuccess,
    }]= useDeleteFinancingPlanMutation();

    const [getFinancingPlan, {
        data: newFinancingPlanData,
        isLoading: financingPlanIsLoading,
        error: financingPlanError,
        isError: financingPlanIsError,
        isSuccess: financingPlanIsSuccess,
    }]= useLazyGetFinancingPlanQuery();

    const updateFinancingPlan = () => {
        getFinancingPlan(reportId);
    }

    useEffect(() => {
        setFinancingPlanData(data)
    }, [data]);

    useEffect(() => {
        if (deleteFinancingPlanIsSuccess){
            toast.success(deleteFinancingPlanData.message);
            updateFinancingPlan();
        }
    }, [deleteFinancingPlanIsSuccess, deleteFinancingPlanData]);

    useEffect(() => {
        if (financingPlanIsSuccess){
            setFinancingPlanData(newFinancingPlanData?.data)
        }
    }, [financingPlanIsSuccess, newFinancingPlanData]);

    useEffect(() => {
        if (deleteFinancingPlanIsError){
            toast.error(deleteFinancingPlanError?.data.message)
            errorHandle(deleteFinancingPlanError);
        }
        if (financingPlanIsError){
            toast.error(financingPlanError?.data.message)
            errorHandle(financingPlanError);
        }
    }, [
        deleteFinancingPlanIsError, deleteFinancingPlanError,
        financingPlanError, financingPlanIsError
    ])

    useEffect(() => {
        financingPlanIsLoading ||
        deleteFinancingPlanIsLoading ?
            dispatch(setLoader(true))
            : dispatch(setLoader(false));
    }, [deleteFinancingPlanIsLoading, financingPlanIsLoading]);

    useEffect(() => {
        if (thead.current) {
            const widths = Array.from(thead.current.querySelectorAll('span')).map(thead => thead?.offsetWidth);
            setCellWidths(widths);
        }
    }, [thead]);


    return (
        <section className="erLoan" ref={headerRef} id="financing_plan">
            {isOpenMoreInfo &&
                <MoreInfoModal
                    title= {translations?.['financing_plan.index.headers.financing_plan']}
                    moreInfo={translations?.['financing_plan.index.more_info.more_info']}
                    close={()=>setOpenMoreInfo(false)}
                />
            }
            <div className="editReport__sectionHeader">
                <div style={{width: '20px', height: '20px'}}>
                    <span onClick={() => hiddenSectionHandler(headerRef)}/>
                </div>
                <h2 onClick={() => hiddenSectionHandler(headerRef)}>
                    {translations?.['financing_plan.index.headers.financing_plan']}
                </h2>
                <MoreInfoButton
                    onClick={()=>setOpenMoreInfo(!isOpenMoreInfo)}
                    className="editReport__sectionHeader__moreInfo"
                    title={translations?.['financing_plan.index.titles.more_info']}
                />
                {!isReportSubmitted &&
                    <AddRowButton
                        className={"editReport__sectionHeader__addRowBtn"}
                        title={translations?.['financing_plan.index.actions.add_row']}
                        onClick={() => setIsOpenToAdd(true)}
                    />
                }
            </div>
            <div className="editReport__table">
                <div className="editReport__table__row editReport__table__header" ref={thead}>
                    <span> {translations?.['financing_plan.index.table_headers.source_of_fund']} </span>
                    <span> {translations?.['financing_plan.index.table_headers.description']} </span>
                    <span> {translations?.['financing_plan.index.table_headers.amount_millions']} </span>
                    <span> {translations?.['financing_plan.index.table_headers.share_percent']} </span>
                </div>
                {
                    financingPlanData?.data && financingPlanData?.data?.map(item =>{
                        return (
                            <React.Fragment key={item.id}>
                                {!(isOpenEdit.show && isOpenEdit.id === item.id) ?
                                    <div className="editReport__table__row" >
                                        <span>{item.source_of_fund}</span>
                                        <span>{item.description}</span>
                                        <span>{item.amount}</span>
                                        <span>{item.share}</span>
                                        {!isReportSubmitted && <div className="editReport__table__settingsButtons">
                                            <button className="editReport__table__deleteBtn"
                                                    onClick={() => deleteFinancingPlan(item.id)}
                                            >
                                                {translations?.['financing_plan.index.actions.delete']}
                                            </button>
                                            <button
                                                className="editReport__table__updateBtn"
                                                onClick={() => setIsOpenEdit({show: true, id: item.id})}>
                                                {translations?.['financing_plan.index.actions.update']}
                                            </button>
                                        </div>}
                                    </div> :
                                    <ItemEdit
                                        reportId={reportId}
                                        descriptionPlaceholder={translations?.['index.index.placeholder.text']}
                                        amountPlaceholder={translations?.['index.index.placeholder.number']}
                                        itemData={item}
                                        setIsOpenEdit={setIsOpenEdit}
                                        cancelTranslation={translations?.['financing_plan.index.actions.cancel']}
                                        saveTranslation={translations?.['financing_plan.index.actions.save']}
                                        getFinancingPlans={updateFinancingPlan}
                                        cellWidths={cellWidths} // Pass the cell widths
                                    />
                            }
                            </React.Fragment>
                        )
                    })
                }
                {(isOpenToAdd && !isReportSubmitted) && <ItemEdit
                    getFinancingPlans={updateFinancingPlan}
                    reportId={reportId}
                    descriptionPlaceholder={translations?.['index.index.placeholder.text']}
                    amountPlaceholder={translations?.['index.index.placeholder.number']}
                    setIsOpenEdit={setIsOpenToAdd}
                    cancelTranslation={translations?.['financing_plan.index.actions.cancel']}
                    saveTranslation={translations?.['financing_plan.index.actions.save']}
                    cellWidths={cellWidths} // Pass the cell widths
                />}
                <div className="editReport__table__row editReport__table__row__total">
                    <span>{translations?.['financing_plan.index.titles.total_project_cost']}:</span>
                    <span></span>
                    <span>${financingPlanData?.total_amount}</span>
                    <span>{financingPlanData?.total_percent}</span>
                </div>
            </div>
        </section>
    )
}
export default FinancingPlan;
